import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AngularEditorConfig } from '@kolkov/angular-editor';
// import { AngularEditorConfig } from '@kolkov/angular-editor';
import { Notice } from 'app/shared/models/class/notice/notice';
import { FaiconService } from 'app/shared/services/faicon/faicon.service';
import { NoticeService } from 'app/shared/services/notice/notice.service';
import { UiService } from 'app/shared/services/ui/ui.service';
import { OpenDialogDeleteElementComponent } from '../open-dialog-delete-element/open-dialog-delete-element.component';

@Component({
  selector: 'app-open-dialog-admin-announce',
  templateUrl: './open-dialog-admin-announce.component.html',
  styleUrls: ['./open-dialog-admin-announce.component.scss'],
  encapsulation: ViewEncapsulation.None

})
export class OpenDialogAdminAnnounceComponent implements OnInit {

  form: UntypedFormGroup;
  isLoading: boolean;
  noticeToEdit: Notice;
  file: any;

  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: 'auto',
    minHeight: '0',
    maxHeight: 'auto',
    width: 'auto',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    placeholder: 'Informations',
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
    fonts: [
      { class: 'arial', name: 'Arial' },
      { class: 'times-new-roman', name: 'Times New Roman' },
      { class: 'calibri', name: 'Calibri' },
      { class: 'comic-sans-ms', name: 'Comic Sans MS' }
    ],

    uploadUrl: '',
    uploadWithCredentials: false,
    sanitize: true,
    toolbarPosition: 'top',
    toolbarHiddenButtons: [
      ['insertVideo'],
      ['fontSize']
    ]
  };

  private extensionsAllowed = ['jpg', 'png', 'jpeg'];

  constructor(
    public dialogRef: MatDialogRef<OpenDialogAdminAnnounceComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: UntypedFormBuilder,
    private noticeService: NoticeService,
    private uiService: UiService,
    private faIconService: FaiconService,
    private dialog: MatDialog
  )
  {
    if (this.data) {
      this.noticeToEdit = this.data;
      if (this.noticeToEdit.thumbImage) {
        this.checkThumbImageValue(this.noticeToEdit);
      }
    }
  }

  ngOnInit(): void {
    this.initForm();
  }

  cancel(): void { this.dialogRef.close(); }

  getFaIcon(faIcon: string): string {
    return this.faIconService.getFaIcon(faIcon);
  }

  selectImage(event: any): void {
    const file = event.target.files[0];
    const type = file.type?.split('/')[1];
    if (!this.extensionsAllowed.includes(type)) {
      this.uiService.showSnackbar(`Uniquement format jpg ou png`);
    } else {
      this.file = file;
    }

  }

  deleteName(): void {
    this.file = null;
  }

  deleteImage(notice: Notice): void {
    const params = {
      disableClose: true,
      data: {
        title: `Supprimer une image`,
        text: `Êtes-vous sûr de vouloir supprimer cette image ?`,
        action: 'updateNotice',
        notice: notice
      }
    };
    const dialogRef = this.dialog.open(OpenDialogDeleteElementComponent, params);
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.noticeToEdit.thumbImage = null;
        this.file = null;
        this.noticeService.noticeUpdate$.next(this.noticeToEdit);
      }
    });

  }

  save(): void {
    this.isLoading = true;
    let blocks: string[] = [];
    const formValue = this.form.value;

    if (formValue.left === true) {
      blocks.push('content_left');
    }
    if (formValue.right === true) {
      blocks.push('content_right');
    }
    const noticeToPost = new Notice (
      formValue.title,
      formValue.content,
      blocks,
      formValue.url,
      formValue.label,
      this.noticeToEdit ? this.noticeToEdit.key : null
    );
    if (this.noticeToEdit) {
      if (this.file) {
        this.noticeService.putNotice(noticeToPost, this.file).subscribe({
          next: data => {
            this.isLoading = false;
            this.uiService.showSnackbar(`L'annonce ${noticeToPost.title} a été modifiée avec succès.`);
            this.noticeService.noticeUpdate$.next(null);
            this.dialogRef.close(data);
          }
        });

      } else {
        noticeToPost.thumbImage = this.noticeToEdit.thumbImage;
        this.noticeService.putNotice(noticeToPost).subscribe({
          next: data => {
            this.isLoading = false;
            this.uiService.showSnackbar(`L'annonce ${noticeToPost.title} a été modifiée avec succès.`);
            this.noticeService.noticeUpdate$.next(null);
            this.dialogRef.close(data);
          }
        });
      }

    } else {
      this.noticeService.postNotice(noticeToPost, this.file).subscribe({
        next: data => {
          this.isLoading = false;
          this.uiService.showSnackbar(`L'annonce ${noticeToPost.title} a été ajoutée avec succès.`);
          this.dialogRef.close(data);
        }
      })
    }
  }

  private checkThumbImageValue(notice: Notice): Notice {
    if (notice.thumbImage.startsWith(`<img src=\"<img`) && notice.thumbImage.endsWith(`>\">`)) {
      const thumbImageFilter = notice.thumbImage.replace(/^<img src=\"/, "").replace(/\">$/, "");
      notice.thumbImage = thumbImageFilter;
    }
    return notice;
  }

  private initForm(): void {
    let title = '';
    let content = '';
    let url = '';
    let label = '';
    let left = false;
    let right = false;

    if (this.noticeToEdit) {
      title = this.noticeToEdit.title;
      content = this.noticeToEdit.content;
      url = this.noticeToEdit.linkUrl;
      label = this.noticeToEdit.linkLabel;
      if (this.noticeToEdit.blocks.includes('content_left')) {
        left = true;
      }
      if (this.noticeToEdit.blocks.includes('content_right')) {
        right = true;
      }
    }

    this.form = this.formBuilder.group({
      title: [title, Validators.required],
      content: [content, Validators.required],
      left: [left],
      right: [right],
      url: [url],
      label: [label]
    });
  }

}
